import React from 'react';
import {
  useSelector,
  useDispatch,
} from 'react-redux';
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import Toolbar from '@mui/material/Toolbar';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import AppBar from '@mui/material/AppBar';

import Container from '@mui/material/Container';
// import TextField from '@mui/material/TextField';
// import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
// import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import Timeline from '@mui/lab/Timeline';

import {
  Button,
  CardContent,
  Popover,
  Typography,
  Pagination,
  Checkbox,
} from '@mui/material';

import {
  getHorseNoteHighlights,
  getHorseNotes,
} from '../../../../../../../redux/horse/actions';
import NoteTypeSelectComponent from '../../../../../../../components/EnumSelects/NoteTypeSelect';
import NoteItem from '../../../../../../../components/NoteItem';
import notesIcon from '../../../../../../../images/unused-undraw-illustrations/notes.svg';

const HorseNotesSelectPopover = ({
  anchorEl,
  open,
  onClose,
  selectedHorseNotes,
  onChangeSelectedHorseNotes,
}) => {
  const dispatch = useDispatch();
  // const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

  // State
  const [pageSize] = React.useState(20);
  const [page, setPage] = React.useState(0);
  const [sortModel] = React.useState([
    {
      field: 'createdTimestamp',
      sort: 'desc',
    },
  ]);
  const [noteTypeFilter, setNoteTypeFilter] = React.useState('');
  // const [startDate, setStartDate] = React.useState(null);
  // const [endDate, setEndDate] = React.useState(null);

  // Redux
  const horse = useSelector((state) => state.horse.horse);
  const horseNotes = useSelector((state) => state.horse.horseNotes);
  const isFetchingHorseNotes = useSelector((state) => state.horse.isFetchingHorseNotes);

  React.useEffect(() => {
    dispatch(getHorseNotes(horse.id, (page - 1), pageSize, sortModel.map((s) => `&sort=${s.field},${s.sort}`), noteTypeFilter || null));
    dispatch(getHorseNoteHighlights(horse.id));
  }, [horse, page, noteTypeFilter]);

  const handleAlternativeTableRowSelect = (horseNote) => {
    if (onChangeSelectedHorseNotes) {
      if (selectedHorseNotes.find((hn) => hn.id === horseNote.id)) {
        // remove
        onChangeSelectedHorseNotes([...selectedHorseNotes.filter((hb) => hb.id !== horseNote.id)])
      } else {
        // add
        onChangeSelectedHorseNotes([...selectedHorseNotes, horseNote])
      }
    }
  }

  const finalHorseNotes = [...selectedHorseNotes.map((n) => ({
    ...n,
    selected: true,
  })), ...horseNotes.content.filter((hn) => !selectedHorseNotes.find((shn) => shn.id === hn.id))]

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      PaperProps={{
        sx: {
          display: 'flex !important',
          flexDirection: 'column !important',
        },
      }}
      slotProps={{
        paper: {
          sx: {
            display: 'flex !important',
            flexDirection: 'column !important',
          },
        },
      }}
    >
      <AppBar
        position="relative"
        color="inherit"
        sx={{
          background: '#fff',
          mb: 2,
        }}
        elevation={2}
      >
        <Container
          maxWidth="100%"
          sx={{
            pt: 1,
            pb: 0.5,
            maxHeight: '90%',
          }}
        >
          <Toolbar disableGutters variant="dense">
            <Grid container spacing={2} justifyContent="space-between">
              <Grid item>
                <Grid container spacing={2} alignItems="center">
                  <Grid item sx={{ minWidth: 175 }}>
                    <NoteTypeSelectComponent
                      value={noteTypeFilter}
                      onChange={(e) => { setNoteTypeFilter(e.target.value); }}
                      includeAllOption
                    />
                  </Grid>
                  {/* <Grid item>
                    <LocalizationProvider dateAdapter={AdapterMoment}>
                      <DatePicker
                        label="Start Date"
                        value={startDate}
                        disabled={isFetchingHorseNotes}
                        onChange={(newValue) => {
                          setStartDate(newValue.toDate());
                        }}
                        renderInput={(params) => <TextField {...params} sx={{ width: 150 }} size="small" />}
                      />
                    </LocalizationProvider>
                  </Grid>
                  <Grid item>
                    <LocalizationProvider dateAdapter={AdapterMoment}>
                      <DatePicker
                        label="End Date"
                        value={endDate}
                        disabled={isFetchingHorseNotes}
                        onChange={(newValue) => {
                          setEndDate(newValue.toDate());
                        }}
                        renderInput={(params) => <TextField {...params} sx={{ width: 150 }} size="small" />}
                      />
                    </LocalizationProvider>
                  </Grid> */}
                  <Grid
                    item
                  >
                    {
                          isFetchingHorseNotes
                            ? (
                              <CircularProgress size={35} />
                            )
                            : (
                              <Box />
                            )
                        }
                  </Grid>
                </Grid>
              </Grid>
              <Grid item>

                <Box
                  sx={{
                    justifyContent: 'flex-end',
                    display: 'flex',
                  }}
                >
                  {/* <Button size="small" startIcon={<Add />} variant="outlined" sx={{ mr: 2 }}
                    onClick={setOpenAddEditBillableModal}>New Transaction</Button> */}
                  <Button variant="contained" onClick={onClose}>Done</Button>
                </Box>
              </Grid>
            </Grid>
          </Toolbar>
        </Container>
      </AppBar>
      <CardContent
        sx={{
          pt: 1,
          pb: 0.5,
          overflow: 'auto',
          flex: 1,
        }}
      >
        <Timeline>
          {

          }
          {
          finalHorseNotes.map((note) => (
            <Box sx={{ display: 'flex' }} key={`horse-note-${note.id}-selected-${note.selected}`}>
              <Checkbox
                color="primary"
                checked={note.selected}
                onChange={() => handleAlternativeTableRowSelect(note)}
                sx={{ mr: 2 }}
              />
              <Box sx={{ flex: 1 }}>
                <NoteItem
                  note={note}
                  horseId={horse.id}
                  pinnedHorseNoteId={horse.activeNote
                    ? horse.activeNote.id
                    : null}
                  key={note.id}
                  includeUserInfo
                  isLoading={isFetchingHorseNotes}
              // onEdit={() => openAddEditNoteModal(note, noteTypeFilter, closeAddEditModalCallbcak)}
                  isAdmin={false}
                  hideActions
                />
              </Box>
            </Box>
          ))
        }
          {
          (!isFetchingHorseNotes && horseNotes.content.length === 0) && (
            <Box sx={{ textAlign: 'center' }}>
              <Typography variant="subtitle1" align="center" component="div" sx={{ m: 4 }}>
                No Notes
              </Typography>
              <img
                src={notesIcon}
                alt="girl with notes"
                style={{
                  width: 250,
                  display: 'block',
                  margin: 'auto',
                  marginBottom: '1rem',
                }}
              />
            </Box>
          )
        }

        </Timeline>

        <Pagination count={horseNotes.totalPages} variant="outlined" page={page} onChange={(event, value) => { setPage(value); }} disabled={isFetchingHorseNotes} />
      </CardContent>
    </Popover>
  );
}

HorseNotesSelectPopover.propTypes = {
  open: PropTypes.bool,
  anchorEl: PropTypes.any,
  onClose: PropTypes.func,
  selectedHorseNotes: PropTypes.func,
  onChangeSelectedHorseNotes: PropTypes.array,
};

HorseNotesSelectPopover.defaultProps = {
  open: false,
  anchorEl: null,
  onClose: () => {},
  selectedHorseNotes: [],
  onChangeSelectedHorseNotes: () => {},
};

export default (HorseNotesSelectPopover);
